import React, {
  useState
} from "react";

import api from "../../api";

import {
  useNavigate
} from "react-router-dom";

function ClientForm() {

  const navigate =
    useNavigate();

  const [form, setForm] =
    useState({
      nom: "",
      post_nom: "",
      prenom: "",
      telephone: "",
      email: "",
      nationalite: "",
      sexe: "",
      adresse: "",
      type_piece: "",
      numero_piece: ""
    });

  const [loading, setLoading] =
    useState(false);

  // =====================
  // CHANGE
  // =====================

  const handleChange =
    (e) => {

      const {
        name,
        value
      } = e.target;

      if (
        name ===
        "telephone"
      ) {

        let cleaned =
          value.replace(
            /[^0-9+]/g,
            ""
          );

        if (
          cleaned.includes(
            "+"
          )
        ) {

          cleaned =
            "+" +
            cleaned.replace(
              /\+/g,
              ""
            );
        }

        setForm({
          ...form,
          [name]:
            cleaned
        });

        return;
      }

      setForm({
        ...form,
        [name]: value
      });
    };

  // =====================
  // SUBMIT
  // =====================

  const handleSubmit =
    async (e) => {

      e.preventDefault();

      if (
        !window.confirm(
          "Confirmer l'enregistrement du client ?"
        )
      ) {
        return;
      }

      setLoading(true);

      try {

        await api.post(
          "/clients",
          form
        );

        navigate(
          "/clients"
        );

      } catch (err) {

        console.error(err);

        alert(
          "Erreur lors de l'enregistrement"
        );

      }

      setLoading(false);
    };

  // =====================
  // RENDER
  // =====================

  return (
    <div className="min-h-[100dvh] bg-gray-100 flex justify-center items-start p-3 md:p-6">

      <div className="w-full max-w-4xl bg-white rounded-2xl shadow-lg p-4 md:p-8">

        {/* HEADER */}
        <div className="mb-6">

          <h2 className="text-2xl md:text-3xl font-bold">
            Nouveau client
          </h2>

          <p className="text-sm text-gray-500 mt-1">
            Remplissez les informations du client
          </p>

        </div>

        <form
          onSubmit={
            handleSubmit
          }
          className="space-y-6"
        >

          {/* IDENTITE */}
          <div>

            <h3 className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
              Identité
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

              <input
                name="nom"
                required
                placeholder="Nom"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-green-400"
              />

              <input
                name="post_nom"
                required
                placeholder="Post-nom"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-green-400"
              />

              <input
                name="prenom"
                required
                placeholder="Prénom"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-green-400"
              />

            </div>

          </div>

          {/* CONTACT */}
          <div>

            <h3 className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
              Contact
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              <input
                name="telephone"
                required
                placeholder="+243..."
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-green-400"
              />

              <input
                type="email"
                name="email"
                required
                value={form.email || ""}
                onChange={handleChange}
                placeholder="Email"
                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
              />

              <input
                name="nationalite"
                required
                placeholder="Nationalité"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-green-400"
              />

              <select
                name="sexe"
                required
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-green-400"
              >

                <option value="">
                  Sexe
                </option>

                <option value="Masculin">
                  Masculin
                </option>

                <option value="Féminin">
                  Féminin
                </option>

              </select>

              <input
                name="adresse"
                required
                placeholder="Adresse"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-green-400 md:col-span-2"
              />

            </div>

          </div>

          {/* PIECE */}
          <div>

            <h3 className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
              Pièce d'identité
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              <select
                name="type_piece"
                required
                value={form.type_piece}
                onChange={handleChange}
                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
              >
                <option value="">
                  Type de pièce
                </option>

                <option value="Carte d'identité">
                  Carte d'identité
                </option>

                <option value="Carte d'électeur">
                  Carte d'électeur
                </option>

                <option value="Passeport">
                  Passeport
                </option>

                <option value="Permis de conduire">
                  Permis de conduire
                </option>

                <option value="Carte de résident">
                  Carte de résident
                </option>

                <option value="Autre">
                  Autre
                </option>
              </select>

              <input
                name="numero_piece"
                required
                placeholder="Numéro pièce"
                onChange={
                  handleChange
                }
                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-green-400"
              />

            </div>

          </div>

          {/* ACTIONS */}
          <div className="flex flex-col md:flex-row gap-3 pt-2">

            <button
              type="button"
              onClick={() =>
                navigate(
                  "/clients"
                )
              }
              className="flex-1 bg-gray-200 hover:bg-gray-300 transition text-gray-800 py-3 rounded-xl font-semibold"
            >
              Annuler
            </button>

            <button
              type="submit"
              disabled={loading}
              className="flex-1 bg-green-600 hover:bg-green-700 transition text-white py-3 rounded-xl font-semibold shadow disabled:opacity-50"
            >
              {loading
                ? "Enregistrement..."
                : "Enregistrer"}
            </button>

          </div>

        </form>

      </div>

    </div>
  );
}

export default ClientForm;